import { SearchModelBase } from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class OrchidBaroListItem extends SearchModelBase {
    id: number = 0;
    customer: string = '';
    uCnee: string = '';
    mot: string = '';
    orderDate: string | null = null;
    fromOrderDate: string | null = null;    
    ToOrderDate: string | null = null;
    orderNo: string = '';
    containerNo: string= '';
    containerSize: string ='';
    custRefNo: string = '';
    scacCode: string = '';
    pkgs: number = 0;
    lbs: number = 0;
    bl: string = '';
    pl: boolean = false;
    ci: boolean = false;
    cbpHold: string = '';
    trType: string = '';
    trStatus: string = '';
    tsStatusDesc: string = '';
    trLocCode: string = '';
    lastEvent: string ='';
    lastEventDate: string|null = null;
    FromLastEventDate: string|null = null;
    ToLastEventDate: string|null = null;

    eta: string|null = null;
    fromETA: string|null = null;
    toETA: string|null = null;
    chbRspCode: string = '';
    chbRspMsg: string = '';
    abiDate: string|null = null;
    fromAbiDate: string|null = null;
    toAbiDate: string|null = null;
    pickupLoc: string = '';
    availDate: string|null = null;
    fromAvailDate: string|null = null;
    toAvailDate: string|null = null;
    lfd: string|null = null;
    fromLFD: string|null = null;
    toLFD: string|null = null;
    carrier: string = '';
    appointment: string = '';
    origin: string = '';
    trackingNo: string = '';
    deliveryDate: string = '';
    departure: string|null = null;
    fromDeparture: string|null = null;
    toDeparture: string|null = null;
    destination: string = '';
    arrivalDate: string|null = null;
    fromArrivalDate: string|null = null;
    toArrivalDate: string|null = null;
    fDestination: string = '';
    fmot: string ='';
    feta: string|null = null;
    fromFETA: string|null = null;
    toFETA: string|null = null;
    //distanceLeft: number = 0;
    trackerStatus: string = '';
    currentLoc: string = '';
    mblNo: string ='';
    hblNo: string = '';
    sharedURL: string ='';
    loadStatus: string = '';
    metd: string | null = null;
    loadId: number = 0;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'S', width: 30, dataIndex: 'status', hiddenInColumnSetup: true }),
        XCol.Create({ col: 1, text: 'Customer', width: 140, dataIndex: 'customer'}),
        XCol.Create({ col: 2, text: 'U.Cnee', width: 140, dataIndex: 'uCnee'}),
        XCol.Create({ col: 3, text: 'MOT', width: 60, dataIndex: 'mot', align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 4, text: 'PRO Date', width: 75, dataIndex: 'orderDate', align: XCol.XAlignType.Center, type: XCol.XCellType.Date }),
        XCol.Create({ col: 5, text: 'PRO #', width: 120, dataIndex: 'orderNo', defaultColumnFocus: true }),
        XCol.Create({ col: 6, text: 'Container #', width: 120, dataIndex: 'containerNo'}),
        XCol.Create({ col: 7, text: 'Size', width: 70, dataIndex: 'containerSize'}),
        XCol.Create({ col: 8, text: 'Cust Ref. #', width: 120, dataIndex: 'custRefNo'}),
        XCol.Create({ col: 9, text: 'Vessel Carrier', width: 100, dataIndex: 'scacCode', align: XCol.XAlignType.Center }),
        XCol.Create({ col: 10, text: 'Pkges', width: 70, dataIndex: 'pkgs', align: XCol.XAlignType.Center, type: XCol.XCellType.Double}),
        XCol.Create({ col: 11, text: 'Weight', width: 80, dataIndex: 'lbs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right,formatString: '#,##0',noNullOrEmptySearch: true}),
        XCol.Create({ col: 12, text: 'B/L', width: 80, dataIndex: 'bl' , align:XCol.XAlignType.Center}),
        XCol.Create({ col: 13, text: 'P/L', width: 50, dataIndex: 'pl', type: XCol.XCellType.Bool, align:XCol.XAlignType.Center }),
        XCol.Create({ col: 14, text: 'C/I', width: 50, dataIndex: 'ci' , type: XCol.XCellType.Bool, align:XCol.XAlignType.Center}),
        XCol.Create({ col: 15, text: 'Remarks', width: 90, dataIndex: 'cbpHold', noNullOrEmptySearch: true}),
        XCol.Create({ col: 16, text: 'Location', width: 80, dataIndex: 'trLocCode'}), //last location
        XCol.Create({ col: 17, text: 'Status', width: 155, dataIndex: 'lastEvent'}), //lastevent
        XCol.Create({ col: 18, text: 'Date', width: 75, dataIndex: 'lastEventDate', align: XCol.XAlignType.Center, type: XCol.XCellType.Date}),  //lastEventDate
        XCol.Create({ col: 19, text: 'Vessel ETA', width: 75, dataIndex: 'eta', align: XCol.XAlignType.Center, type: XCol.XCellType.Date}),
        XCol.Create({ col: 20, text: 'CBP', width: 50, dataIndex: 'chbRspCode', align: XCol.XAlignType.Center, noNullOrEmptySearch: true }),
        XCol.Create({ col: 21, text: 'Date', width: 75, dataIndex: 'abiDate', align: XCol.XAlignType.Center, type: XCol.XCellType.Date}),
        XCol.Create({ col: 22, text: 'P/U Loc', width: 120, dataIndex: 'pickupLoc'}),
        XCol.Create({ col: 23, text: 'Avail Date', width: 80, dataIndex: 'availDate',type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 24, text: 'LFD', width: 75, dataIndex: 'lfd',type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 25, text: 'Carrier (Drayage)', width: 120, dataIndex: 'carrier'}),
        XCol.Create({ col: 26, text: 'Appointment', width: 120, dataIndex: 'appointment'}),
        XCol.Create({ col: 27, text: 'Origin Whse', width: 120, dataIndex: 'origin'}),
        XCol.Create({ col: 28, text: 'Tracker No', width: 90, dataIndex: 'trackingNo', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 29, text: 'Delivery Date', width: 85, dataIndex: 'deliveryDate',}),
        XCol.Create({ col: 30, text: 'Destination', width: 120, dataIndex: 'destination'}),
        XCol.Create({ col: 31, text: 'Arrival Date', width: 80, dataIndex: 'arrivalDate', align: XCol.XAlignType.Center, type: XCol.XCellType.Date}),
        XCol.Create({ col: 32, text: 'Foreign Destination', width: 120, dataIndex: 'fDestination'}),
        XCol.Create({ col: 33, text: 'Delivery By', width: 60, dataIndex: 'fmot', align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 34, text: 'ETA', width: 75, dataIndex: 'feta', align: XCol.XAlignType.Center, type: XCol.XCellType.Date}),
        //XCol.Create({ col: 35, text: 'Status', width: 90, dataIndex: 'distanceLeft', align: XCol.XAlignType.Center, type: XCol.XCellType.Double}),
        XCol.Create({ col: 35, text: 'INL Status', width: 90, dataIndex: 'trackerStatus'}),
        XCol.Create({ col: 36, text: 'INL Location', width: 180, dataIndex: 'currentLoc'})
    ];

    public static getExportCollection(): XCol.XExportColumn[] {
        return OrchidBaroListItem.ExportCollection;
    };

    public static OrderBy = { orderBy: OrchidBaroListItem.prototype.id, orderByAscending: false };

    public static formatData(data: OrchidBaroListItem[]) {
        return data.map((d: OrchidBaroListItem) => ({
            ...d,
        }));
    }

    public static MapSearchFields: { [key: string]: { [key: string]: string } } = {

        arrivalDate: {from: 'fromArrivalDate', to: 'toArrivalDate'},
        departure: {from: "fromDeparture", to: 'toDeparture'},
        pkgs: {from: "fromPkgs", to: "toPkgs"},
        eta: {from: "fromETA", to: "toETA"},
        lbs: {from: "fromLbs", to: "toLbs"},
        lfd: {from: "fromLFD", to: "toLFD"},
        orderDate: {from: "fromOrderDate", to:"toOrderDate"},
        availDate: {from: "fromAvailDate", to:"toAvailDate"},
        abiDate: {from: "fromAbiDate", to:"toAbiDate"},
        feta: {from: "fromFETA", to:"toFETA"},
        lastEventDate: {from: "fromLastEventDate", to: "toLastEventDate"},

    }
}